import { INVOICE_LABELS, ALL } from 'store/invoices';

const examStatusList = Object.entries(INVOICE_LABELS).map(([id, title]) => ({ id, title }));

export const statusList = [{ id: ALL, title: 'Alle' }, ...examStatusList];
